module.exports = __webpack_public_path__ + "img/SES_180250210.2729bd10.jpg";